export const CREATE_TRANSPORT = 'CREATE_TRANSPORT'
export const SET_SELECTED_TRANSPORT_PRIORITY = 'SET_SELECTED_TRANSPORT_PRIORITY'
export const SET_SELECTED_TRANSPORT_STATUS = 'SET_SELECTED_TRANSPORT_STATUS'
export const SET_SELECTED_TRANSPORT_INCOTERMS = 'SET_SELECTED_TRANSPORT_INCOTERMS'
export const SET_SELECTED_TRANSPORT_COMMENT = 'SET_SELECTED_TRANSPORT_COMMENT'
export const SET_SELECTED_TRANSPORT = 'SET_SELECTED_TRANSPORT'
export const SET_SELECTED_TRANSPORT_PICKUP_DELIVERY = 'SET_SELECTED_TRANSPORT_PICKUP_DELIVERY'
export const SET_SELECTED_TRANSPORT_RESTRICTIONS = 'SET_SELECTED_TRANSPORT_RESTRICTIONS'
export const SET_SELECTED_TRANSPORT_ADD_UNITS = 'SET_SELECTED_TRANSPORT_ADD_UNITS'
export const SET_SELECTED_TRANSPORT_REMOVE_UNITS = 'SET_SELECTED_TRANSPORT_REMOVE_UNITS'
export const UPDATE_TRANSPORT_UNITS = 'UPDATE_TRANSPORT_UNITS'

export const SET_SELECTED_ORDER_ORIGIN_LOCATION = 'SET_SELECTED_ORDER_ORIGIN_LOCATION'
export const SET_SELECTED_ORDER_DESTINATION_LOCATION = 'SET_SELECTED_ORDER_DESTINATION_LOCATION'

export const SET_TRANSPORT_ENUMS = 'SET_TRANSPORT_ENUMS'

export const IS_CREATING_SHIPMENT = 'IS_CREATING_SHIPMENT'
